import { useSelector } from 'react-redux'

export const useIsMocoInMySelection = (moco: string) => {
  const mySelection = useSelector(state => state.frameAdvisor.mySelection)
  return mySelection.some(product => product.moco === moco)
}
